export function dedupe(
    data, 
    isDupe = (a, b) => a === b
) {
    const results = [];
    data.forEach(d => {
        if (!results.find(r => isDupe(r, d))) {
            results.push(d);
        }
    });
    return results;
}
